import React from 'react';

import {useGlobal} from '../../../../../api/hooks/useGlobal.hook';
import {TypographyVariantsEnum} from '../../../../../utils/_enums/typeography-variants.enum';
import {getLocaleEthPrice, getLocalePrice} from '../../../../../utils/_helper/locale-helper';
import {Typography} from '../../../typography/typography';
import styles from './price-box.module.scss';

interface PriceBoxProps {
    ethPrice: number;
    fiatPrice: number;
    currencies?: 'ETH' | 'FIAT_AND_ETH';
    withTaxRate?: boolean;
}

const PriceBox: React.FC<PriceBoxProps> = (props: PriceBoxProps) => {
    const data = useGlobal();

    return (
        <div className={styles['price-box']}>
            <Typography
                className={styles['price']}
                variant={TypographyVariantsEnum.HEADING3_BOLD}
                element={'span'}
            >
                {props.currencies === 'FIAT_AND_ETH'
                    ? `${getLocalePrice(props.fiatPrice)}€`
                    : `${getLocaleEthPrice(props.ethPrice)}Ξ`}
            </Typography>
            <Typography
                className={`${styles['price']} ${props.currencies === 'ETH' ? styles['secondary-price'] : ''}`}
                variant={props.currencies === 'FIAT_AND_ETH'
                    ? TypographyVariantsEnum.HEADING3_BOLD
                    : TypographyVariantsEnum.HEADING4_LIGHT}
                element={'span'}
            >
                {props.currencies === 'FIAT_AND_ETH'
                    ? `${getLocaleEthPrice(props.ethPrice)}Ξ`
                    : `(${getLocalePrice(props.fiatPrice)}€)`}
            </Typography>
            {
                props.withTaxRate
                    ? <Typography
                        variant={TypographyVariantsEnum.CAPTION}
                        element={'span'}
                    >
                        {data?.salesBox?.valueAddedTax ?? ''}
                    </Typography>
                    : undefined
            }
        </div>
    );
};

export default PriceBox;

PriceBox.defaultProps = {
    currencies: 'FIAT_AND_ETH'
}